import React from "react";

import { passwordValidator } from "src/utils";

import { ErrorMessage } from "./error_message";

const PasswordInput = ({ form, newPassword, confirmPassword }) => {
  // eslint-disable-next-line one-var
  let name, id, title, required, validate;
  if (confirmPassword) {
    name = "password_repeat";
    id = "js-password-repeat";
    title = "Confirm Password";
    required = "Please confirm your new password.";
    validate = (value) =>
      value === form.watch("realpassword") ? true : "The passwords do not match.";
  } else if (newPassword) {
    name = "realpassword";
    id = "js-new-password";
    title = "New Password";
    required = "Please provide a valid password.";
    validate = passwordValidator({
      email: window.context?.email,
    });
  } else {
    // NOTE: there are good reasons why the name of this input is realpassword.
    // See https://app.asana.com/0/1199508238968936/1199161091094173, and
    // don't change this unless you know what you're doing.
    name = "realpassword";
    id = "js-password";
    title = "Password";
    required = "Password is required";
  }
  const error = form.errors[name];

  return (
    <>
      {/*
      NOTE: the existence of the dummy field below is related to
      why we need to use names like realemail and realpassword
      in the fields we actually care about.
      See https://app.asana.com/0/1199508238968936/1199161091094173, and
      don't change this unless you know what you're doing.
      */}
      <input style={{ display: "none" }} type="password" name="password-fake" />
      <label className="mb5">
        <p className="text-black-tint-40 bold body-s mb1">{title}</p>
        <input
          style={{
            outlineColor: error ? "var(--red)" : "var(--blue)",
          }}
          id={id}
          name={name}
          type="password"
          autoComplete="chrome-off"
          className="fds-input body-s"
          ref={form.register({ required, validate })}
        />

        {error ? <ErrorMessage msg={error.message} /> : null}
      </label>
    </>
  );
};

export { PasswordInput };
